import React from 'react';

import { Flex } from '@mantine/core';
import { DataNotFoundAlert } from 'components/DataNotFoundAlert';
import { ChatConversationView } from 'components/SmartAssistantComponents/ChatConversationView';
import { useChatMessageHandling } from 'hooks/use-chat-message-handling';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SMART_ASSISTANT_COLOR_THEME } from 'shared/constants/smart-assistant';

interface ResourcePlaygroundProps {
  resourceId: string;
  chatHandling: ReturnType<typeof useChatMessageHandling>;
}

export function ResourcePlayground({ resourceId, chatHandling }: ResourcePlaygroundProps) {
  const { t } = useTranslation();
  const { messages, sendMessage, isStreamingResponse, activeConversation, addNewMessageToConversation } = chatHandling;

  if (!resourceId) return <DataNotFoundAlert />;

  return (
    <Flex
      direction="column"
      w="100%"
      h="100%"
      style={{
        flex: 1,
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <ChatConversationView
        w="100%"
        style={{ flex: 1, minHeight: 0 }}
        messages={messages}
        m={0}
        onSend={sendMessage}
        conversationId={activeConversation.id}
        smartAssistantVisualConfig={{
          ...DEFAULT_SMART_ASSISTANT_COLOR_THEME,
          assistantName: t('SMART_ASSISTANT.RESOURCE_AGENT_TITLE'),
          assistantWelcomeMessage: '',
          assistantAvatar: <></>,
          showBadge: false,
          assistantBadgeTitle: ''
        }}
        isStreamingResponse={isStreamingResponse}
        addNewMessageToConversation={addNewMessageToConversation}
        hideMargins
      />
    </Flex>
  );
}
